var _defs, _circle, _polygon, _polygon2, _polygon3, _polygon4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThrusters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "thrustersJrPanel",
    "data-name": "Thrusters Jr Panel",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 134 134",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Thrusters-cls-1{fill:#14163d;}.Thrusters-cls-2{fill:#94effd;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "Thrusters-cls-1",
    cx: 67,
    cy: 67,
    r: 67
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "Thrusters-cls-2",
    points: "51.69 47.86 67 34.46 82.31 47.86 67 13.4 51.69 47.86"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "Thrusters-cls-2",
    points: "82.31 86.14 67 99.54 51.69 86.14 67 120.6 82.31 86.14"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "Thrusters-cls-2",
    points: "49.77 82.31 36.37 67 49.77 51.69 15.31 67 49.77 82.31"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "Thrusters-cls-2",
    points: "84.23 51.69 97.63 67 84.23 82.31 118.69 67 84.23 51.69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThrusters);
export default __webpack_public_path__ + "static/media/Thrusters.ca3d4d3fd985d02acc16808268a65fdc.svg";
export { ForwardRef as ReactComponent };